import React, { ReactNode, Context } from 'react'
import { ActiveTabManager } from './active-tab-manager'
import { TabContextProps } from './tab-context'
import { TabAnimationManager } from './tab-animation-manager'

/**
 * This is the parent component for all tab components.
 * This component passes data and methods via React context.
 * Context consumers will have access to these values.
 */
export function TabManager<TTabs extends string>({
  context: TabContext,
  defaultTabID,
  children
}: {
  readonly context: Context<TabContextProps<TTabs>>
  readonly defaultTabID: TTabs
  readonly children: ReactNode
}) {
  return (
    <ActiveTabManager<TTabs> defaultTabID={defaultTabID}>
      {({ setCurrentTabID, currentTabID, previousTabID }) => {
        return (
          <TabAnimationManager>
            {({
              transitionToggleFlag,
              updateToggleFlag,
              tabHeadingWidths,
              updateTabHeadingWidths
            }) => {
              return (
                <TabContext.Provider
                  value={{
                    currentTabID,
                    previousTabID,
                    setCurrentTabID,
                    transitionToggleFlag,
                    updateToggleFlag,
                    tabHeadingWidths,
                    updateTabHeadingWidths
                  }}
                >
                  {children}
                </TabContext.Provider>
              )
            }}
          </TabAnimationManager>
        )
      }}
    </ActiveTabManager>
  )
}
